import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';
import { FEATURES } from "../../../../../config/features";

const DepartmentTable = ({ data, onEdit, currentPage, setCurrentPage }) => {
  const headers = [
    "ID",
    ...(FEATURES.USE_DIM_EMPLOYEETYPE_DEPARTMENT ? ["Employee Type"] : []),
    ...(FEATURES.USE_DIM_DIVISION_DEPARTMENT ? ["Division"] : []),
    ...(FEATURES.DEPARTMENT_CODE ? ["Code"] : []),
    "Description",
    "Status",
    "Actions"
  ];

  const accessors = [
    "id",
    ...(FEATURES.USE_DIM_EMPLOYEETYPE_DEPARTMENT ? ["employeeTypeDescription"] : []),
    ...(FEATURES.USE_DIM_DIVISION_DEPARTMENT ? ["divisionDescription"] : []),
    ...(FEATURES.DEPARTMENT_CODE ? ["code"] : []),
    "description",
    "isActive",
    "actions"
  ];

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: true,
    },
  ];

  return (
    <CreateTable
      tableName={"Department List"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
      customRenderers={{
        isActive: (val) => (
          <span className={`rounded-full px-2 py-1 text-xs ${val ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
            {val ? "Active" : "Inactive"}
          </span>
        )
      }}
    />
  );
};

export default DepartmentTable;